"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.statistics.title': 'Estadísticas de tutoriales',
    'tutorial.statistics.details': 'Participantes y progreso del tutorial',
    'tutorial.statistics.subtitle': 'Selecciona un tutorial para ver el progreso de los participantes.',
    'tutorial.statistics.tutorial': 'Tutorial',
    'tutorial.statistics.category': 'Categoría',
    'tutorial.statistics.actions': 'Acciones',
    'tutorial.statistics.viewParticipants': 'Ver participantes',
    'tutorial.statistics.search': 'Buscar',
    'tutorial.statistics.retry': 'Reintentar',
    'tutorial.statistics.refresh': 'Actualizar',
    'tutorial.statistics.back': 'Volver a los tutoriales',
    'tutorial.statistics.pagination': 'Páginas de tutoriales',
    'tutorial.statistics.previous': 'Anterior',
    'tutorial.statistics.next': 'Siguiente',
    'tutorial.statistics.participants': 'Participantes',
    'tutorial.statistics.participant': 'Participante',
    'tutorial.statistics.identity': 'Tipo de participante',
    'tutorial.statistics.registered': 'Usuario registrado',
    'tutorial.statistics.guest': 'Invitado',
    'tutorial.statistics.currentStep': 'Último paso guardado',
    'tutorial.statistics.currentSection': 'Última sección guardada',
    'tutorial.statistics.tasks': 'Tareas completadas',
    'tutorial.statistics.progress': 'Progreso',
    'tutorial.statistics.progressExplanation': 'El progreso es el porcentaje de tareas del tutorial completadas por cada participante. La posición guardada no indica finalización.',
    'tutorial.statistics.notStarted': 'Sin posición guardada',
    'tutorial.statistics.noTasks': 'Sin tareas',
    'tutorial.statistics.emptyTutorials': 'No se encontraron tutoriales.',
    'tutorial.statistics.emptyParticipants': 'Este tutorial aún no tiene participantes.',
    'tutorial.statistics.loadFailed': 'No se pudieron cargar las estadísticas del tutorial.',
    'tutorial.statistics.time_data': 'Datos de tiempo del participante en el tutorial',
    'tutorial.statistics.viewTimeData': 'Ver datos de tiempo',
    'tutorial.statistics.time': 'Tiempo en la sección',
};
